export default {"src":"/_next/static/media/firmware-analysis.0b604148.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};